module.exports = __webpack_public_path__ + "img/about-gradient.1136a072.webp";